import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { Separator } from '../components/Separator';
import { EstablishmentsSection } from '../components/EstablishmentsSection';
import { NewsSection } from '../components/NewsSection';
import { TerritoriesSection } from '../components/TerritoriesSection';
import { StatsSection } from '../components/StatsSection';
import { EventsSection } from '../components/EventsSection';
import { Footer } from '../components/Footer';
import { SEO } from '../utils/seo';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-arih-dark" data-id="element-475">
      <SEO title="Accueil" description="Association Régionale de l'Industrie Hôtelière Agadir Souss Massa - Développer l'industrie hôtelière et le tourisme dans la région de Agadir Souss Massa" keywords="ARIH, Agadir, Souss Massa, hôtellerie, tourisme, association hôtelière, Maroc" ogImage="https://cdn.magicpatterns.com/uploads/4jmG5nr6j1U3Bar2ezcCkj/676d82ed848816903d4d4c1c_AGADIR-7-3.png" data-id="element-476" />
      <Navbar data-id="element-477" />
      <main data-id="element-478">
        <HeroSection data-id="element-479" />
        <Separator data-id="element-480" />
        <EstablishmentsSection data-id="element-481" />
        <Separator data-id="element-482" />
        <NewsSection data-id="element-483" />
        <TerritoriesSection data-id="element-484" />
        <StatsSection data-id="element-485" />
        <EventsSection data-id="element-486" />
      </main>
      <Footer data-id="element-487" />
    </div>;
}